import { ComponentType } from 'react';
import { removeLanguageFromPathname } from '../routes/language';
import { openBrowser, openWhatsap } from './flutter';
import iBANList, { IIbanList } from './iBANList';

function activeLanguage() {
  if (localStorage.getItem('language') === 'kz') {
    return 'kk';
  }
  if (localStorage.getItem('language') === 'ru') {
    return 'ru';
  }
  return localStorage.getItem('language') || 'kk';
}

function isBlankUrl(url: string) {
  return url.startsWith('http');
}

export function formatDateFull(date: string | number | Date) {
  // 13 апреля 2022 г.
  const today = new Date(date);
  const options: any = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return today.toLocaleDateString(
    activeLanguage() === 'ru'
      ? 'ru-RU'
      : activeLanguage() === 'kk'
      ? 'kk-KZ'
      : 'en-US',
    options
  );
}

function calcEndDate(startDt: number | string, add_period: number | string) {
  const st = new Date(startDt).setMonth(
    new Date(startDt).getMonth() + Number(add_period)
  );
  return new Date(st).setDate(new Date(st).getDate() - 1);
}

function calcEndDateAgent(
  startDt: number | string,
  add_period: number | string
): Date {
  const date = new Date(startDt);
  date.setMonth(date.getMonth() + Number(add_period));
  date.setDate(date.getDate() - 1);
  return date;
}

function calcDayOfYear() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now.getTime() - start.getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.floor(diff / oneDay);
}

function iBANCheck(iBan: string): IIbanList | null {
  const bankCode = iBan.slice(4, 7);
  const list = iBANList;
  const bank = list.find((item) => item.bankCode === bankCode);
  if (bank) {
    console.log(bank);
    return bank;
  }
  return null;
}

async function ow(phone: string, text: string) {
  try {
    const _res = await openWhatsap(phone, text);
    console.log('call res', _res);
  } catch (e) {
    alert('сбой');
  }
}

async function openMobileBrowser(url: string) {
  try {
    const _res = await openBrowser(url);
    console.log('call res', _res);
  } catch (e) {
    alert('сбой');
  }
}

async function base64ToFile(base64Data: string) {
  try {
    console.log(base64Data);
    const _res = await fetch(`data:image/jpeg;base64,${base64Data}`);
    const blob = await _res.blob();
    return blob; // new File([blob], fileName, { type: 'image/png' });
  } catch (e) {
    console.log(e);
    alert('сбой base64ToFile');
  }
  return null;
}

function isAdult(iin: string): boolean {
  // Проверяем длину ИИН
  if (iin.length !== 12) {
    return false;
  }

  // Извлекаем дату из ИИН
  const dateString = iin.substring(0, 6);
  let year = parseInt(dateString.substring(0, 2), 10);
  const month = parseInt(dateString.substring(2, 4), 10);
  const day = parseInt(dateString.substring(4, 6), 10);

  // Получаем текущую дату
  const currentDate = new Date();

  // Получаем год, месяц и день текущей даты
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Месяцы в JavaScript нумеруются с 0
  const currentDay = currentDate.getDate();

  const currentYearLastTwoDigits = currentYear % 100;

  console.log(currentYearLastTwoDigits);

  // Учитываем правило начала года в формате ИИН
  if (year >= 0 && year <= currentYearLastTwoDigits) {
    year += 2000;
  } else if (year >= currentYearLastTwoDigits && year <= 99) {
    year += 1900;
  }

  // Вычисляем возраст
  let age = currentYear - year;

  // Проверяем, был ли уже ДР в текущем году
  if (currentMonth < month || (currentMonth === month && currentDay < day)) {
    age -= 1;
  }

  // Проверяем, является ли возраст больше или равным 18
  return age >= 18;
}
const lazyRetry = (
  fn: ComponentImportFunction,
  retriesLeft = 5,
  interval = 1000
): Promise<{ default: ComponentType<any> }> =>
  new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error: Error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            if (
              /Loading chunk [\d]+ failed/.test(error.message) ||
              /Loading CSS chunk [\d]+ failed/.test(error.message)
            ) {
              reject(error);
              window.location.reload();

              return;
            }

            reject(error);
            return;
          }
          lazyRetry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });

export type ComponentImportFunction = () => Promise<{
  default: ComponentType<any>;
}>;

export const reachYandexGoal = (
  goal: string,
  path?: string,
  order_price?: string,
  currency?: string
) => {
  if (!path || path === removeLanguageFromPathname(window.location.pathname)) {
    console.log(goal, window.location.pathname);
    const yandex = (window as any).ym;
    if (yandex) {
      yandex(
        93589534,
        'reachGoal',
        goal,
        order_price ? { order_price, currency: currency || 'KZT' } : undefined
      );
    } else {
      console.warn('Yandex.Metrika is not initialized');
    }
  }
};

function calculateAge(birthDateString: string): number {
  const birthDate = new Date(birthDateString);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  // Если текущий месяц раньше месяца рождения, или если это тот же месяц, но текущий день раньше дня рождения,
  // тогда нужно уменьшить возраст на 1
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    // eslint-disable-next-line no-plusplus
    age -= 1;
  }
  return age;
}

export function outOfService(
  start: string = '2025-01-06T20:00:00+07:00',
  end: string = '2025-01-07T10:00:00+07:00'
): boolean {
  try {
    // Создаем объект Date для startDate и endDate в таймзоне UTC+5
    const startDate = new Date(start);
    const endDate = new Date(end);

    const almatyOffset = 5 * 60; // Разница в минутах между часовым поясом Алматы и UTC (GMT+5)

    // Получаем текущую дату в таймзоне UTC+5
    const currentDate = new Date();
    currentDate.setMinutes(
      currentDate.getMinutes() + currentDate.getTimezoneOffset() + almatyOffset
    ); // Коррекция времени для UTC+5

    // Сравниваем текущую дату с заданными датами
    if (currentDate >= startDate && currentDate < endDate) {
      return true;
    }
    return false;
  } catch (e) {
    console.error(e);
    return false;
  }
}

function isBank(url: string): boolean {
  const params = new URLSearchParams(url);
  if (params.has('mode') && params.has('lang')) {
    return true;
  }
  return false;
}

export function getFileTypeFromBase64(base64String: string): string {
  const binary = atob(base64String.split(',')[1] || base64String);
  const bytes = Array.from(binary)
    .slice(0, 4)
    .map((char) => char.charCodeAt(0));
  const hex = bytes.map((b) => b.toString(16).padStart(2, '0')).join('');

  const fileSignatures: Record<string, string> = {
    '25504446': 'PDF',
    ffd8ffe0: 'JPEG',
    ffd8ffe1: 'JPEG',
    ffd8ffe2: 'JPEG',
    '89504e47': 'PNG',
    '47494638': 'GIF',
    '504b0304': 'DOCX/XLSX (Office Open XML)',
    d0cf11e0: 'DOC/XLS (Office 97-2003)',
    '494433': 'MP3',
  };

  return fileSignatures[hex] || 'Unknown file type';
}

export function getFileExtension(fileType: string): string {
  const extensions: Record<string, string> = {
    PDF: 'pdf',
    JPEG: 'jpg',
    PNG: 'png',
    GIF: 'gif',
    ZIP: 'zip',
    MP3: 'mp3',
    'DOC/XLS (Office 97-2003)': 'doc',
    'DOCX/XLSX (Office Open XML)': 'docx',
  };

  return extensions[fileType] || 'bin';
}

export const base64ToFileNew = (
  base64String: string,
  fileName: string = 'file'
): File => {
  // const arr = base64String.split(',');
  // const mime = arr[0].match(/:(.*?);/)?.[1] || '';
  // const bstr = atob(arr[1]);
  const bstr = atob(base64String);
  const n = bstr.length;
  const u8arr = new Uint8Array(n);

  for (let i = 0; i < n; i += 1) {
    u8arr[i] = bstr.charCodeAt(i);
  }

  const fileType = getFileTypeFromBase64(base64String);

  // MIME типы для сопоставления
  const mimeTypes: Record<string, string> = {
    PDF: 'application/pdf',
    JPEG: 'image/jpeg',
    PNG: 'image/png',
    GIF: 'image/gif',
    ZIP: 'application/zip',
    MP3: 'audio/mpeg',
    'DOC/XLS (Office 97-2003)': 'application/vnd.ms-office',
    'DOCX/XLSX (Office Open XML)':
      'application/vnd.openxmlformats-officedocument',
  };

  const mimeType = mimeTypes[fileType] || 'application/octet-stream';

  return new File([u8arr], `${fileName}.${getFileExtension(fileType)}`, {
    type: mimeType,
  });
};

// Массив праздников
const holidays = [
  new Date(2025, 0, 1), // 1 января
  new Date(2025, 0, 2), // 2 января
  new Date(2025, 0, 3), // 3 января
  new Date(2025, 0, 7), // 7 января
  new Date(2025, 2, 10), // 10 марта
  new Date(2025, 2, 21), // 21 марта
  new Date(2025, 2, 24), // 24 марта
  new Date(2025, 2, 25), // 25 марта
  new Date(2025, 4, 1), // 1 мая
  new Date(2025, 4, 7), // 7 мая
  new Date(2025, 4, 9), // 9 мая
  new Date(2025, 5, 6), // 6 июня
  new Date(2025, 6, 7), // 7 июля
  new Date(2025, 8, 1), // 1 сентября
  new Date(2025, 9, 27), // 27 октября
  new Date(2025, 11, 16), // 16 декабря
];

export function isHoliday(date: Date) {
  return holidays.some(
    (holiday) => holiday.toDateString() === date.toDateString()
  );
}

export function isWeekend(date: Date) {
  return date.getDay() === 0 || date.getDay() === 6;
}

export function convertTimeToAlmaty(date: Date) {
  const currentTime = date.getTime();
  const timezoneOffset = date.getTimezoneOffset(); // Разница в минутах между местным и UTC временем
  const almatyOffset = 5 * 60; // Разница в минутах между часовым поясом Алматы и UTC (GMT+5)

  const localTime = currentTime + timezoneOffset * 60 * 1000; // Приводим к местному времени
  const almatyTime = localTime + almatyOffset * 60 * 1000; // Приводим к времени в Алматы

  return new Date(almatyTime);
}

export function isWorkingDayOver(date: Date) {
  if (date.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)) {
    const currentDate = new Date();
    const currentHours = new Date(convertTimeToAlmaty(currentDate)).getHours();

    return currentHours >= 18;
  }
  return false;
}

function isWebview() {
  const { navigator } = window;
  const { userAgent } = navigator;
  const normalizedUserAgent = userAgent.toLowerCase();
  const { standalone }: any = navigator;

  console.log('params', window.location.search);

  const isIos = /ip(ad|hone|od)/.test(normalizedUserAgent);
  const isAndroid = /android/.test(normalizedUserAgent);
  const isSafari = /safari/.test(normalizedUserAgent);
  const isMac = /macintosh|mac os x/.test(normalizedUserAgent);
  return (
    (isAndroid && /; wv\)/.test(normalizedUserAgent)) ||
    (isIos && !standalone && !isSafari) ||
    (isMac && !standalone && !isSafari)
  );
}

function detectPlatform(location: Location): string {
  try {
    // return 'JusanBankView';
    // return 'flutter';
    const bank = isBank(location.search);
    const bank2 = location.hostname === 'mobile.jgarant.kz';
    if (bank || bank2) {
      return 'JusanBankView';
    }

    return 'JusanBankView';
  } catch (e) {
    console.error(e);
    return 'JusanBankView';
  }
}

function getMonthDifference(startDateStr: string, endDateStr: string): number {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const startYear = startDate.getFullYear();
  const startMonth = startDate.getMonth();
  const endYear = endDate.getFullYear();
  const endMonth = endDate.getMonth();

  const differenceInMonths =
    (endYear - startYear) * 12 + (endMonth - startMonth);

  return differenceInMonths;
}

function calcProcent(startDateStr: string, endDateStr: string) {
  const insuranceDuration = getMonthDifference(startDateStr, endDateStr); // на сколько застрохован в месяцах
  const left = getMonthDifference(new Date().toISOString(), endDateStr); // сколько осталось

  const res = (left * 100) / insuranceDuration;
  // console.log('res', res);
  return res;
}

function toLower(data: string | null | undefined): string {
  try {
    if (data === null) {
      return '';
    }

    if (data === undefined) {
      return '';
    }

    return data.toLocaleLowerCase();
  } catch (e) {
    return '';
  }
}

function replaceCharactersExceptFirst(inputString: string) {
  if (inputString.length <= 1) {
    return inputString; // Если строка пуста или состоит из одного символа, то ничего не меняем.
  }

  const firstChar = inputString[0]; // Получаем первый символ
  const replacementString = firstChar + '*'.repeat(inputString.length - 1); // Создаем строку из звездочек, длиной на 1 меньше, чем исходная строка

  return replacementString;
}

function formatPhoneNumber(phone: string): string {
  // Убедимся, что номер состоит только из цифр
  const cleaned = phone.replace(/\D/g, '');

  if (cleaned.length !== 11 || !cleaned.startsWith('7')) {
    throw new Error('Некорректный номер телефона');
  }

  const countryCode = '+7';
  const areaCode = cleaned.slice(1, 4); // Код города или оператора
  const firstPart = cleaned.slice(4, 7); // Первая часть номера
  const secondPart = cleaned.slice(7, 9); // Вторая часть номера
  const thirdPart = cleaned.slice(9); // Третья часть номера

  return `${countryCode}(${areaCode})${firstPart}${secondPart}${thirdPart}`;
}

export function outOfServiceEveryDay(): boolean {
  try {
    const almatyOffset = 5 * 60; // Разница в минутах между часовым поясом Алматы и UTC (GMT+5)

    // Получаем текущую дату в таймзоне UTC+5
    const currentDate = new Date();
    currentDate.setMinutes(
      currentDate.getMinutes() + currentDate.getTimezoneOffset() + almatyOffset
    ); // Коррекция времени для UTC+5

    // Извлекаем часы и минуты текущей даты
    const currentHours = currentDate.getHours();
    const currentMinutes = currentDate.getMinutes();

    // Проверяем, находится ли текущее время в диапазоне 18:00–23:59 или 00:00–11:00
    if (
      (currentHours >= 18 && currentHours < 24) || // С 18:00 до полуночи
      (currentHours >= 0 && currentHours < 11) // С полуночи до 11:00
    ) {
      return true;
    }
    return false;
  } catch (e) {
    console.error(e);
    return false;
  }
}

function isAfter(startDate: Date | null, endDate: Date | null) {
  const results =
    startDate && endDate
      ? new Date(startDate).getTime() > new Date(endDate).getTime()
      : false;

  return results;
}

export function getNextWorkingDays(startDate: Date, limit: number) {
  const result: Date[] = [];
  const currentDate = new Date(startDate);

  // Проверка текущего дня перед началом цикла
  if (
    !isWeekend(currentDate) &&
    !isHoliday(currentDate) &&
    !isWorkingDayOver(currentDate)
  ) {
    result.push(new Date(currentDate));
  }

  for (let count = result.length; count < limit; ) {
    currentDate.setDate(currentDate.getDate() + 1);

    if (!isWeekend(currentDate) && !isHoliday(currentDate)) {
      result.push(new Date(currentDate));
      count += 1;
    }
  }

  return result;
}

export function fNumberWithSpaces(
  inputValue: string | number | null,
  currency = true,
  currencyValue = '₸'
) {
  if (inputValue === null || inputValue === undefined) return '-';
  // if (typeof inputValue === 'string') return inputValue;
  return (
    String(inputValue).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
    (currency ? ` ${currencyValue}` : '')
  );
}

export const downloadFile = async (url: string, filename: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export {
  formatPhoneNumber,
  replaceCharactersExceptFirst,
  toLower,
  calcProcent,
  detectPlatform,
  isWebview,
  calculateAge,
  calcEndDate,
  calcEndDateAgent,
  calcDayOfYear,
  iBANCheck,
  ow,
  openMobileBrowser,
  base64ToFile,
  activeLanguage,
  isBlankUrl,
  isAdult,
  lazyRetry,
  isAfter,
};
